

export const getPeriodNameArray = (periodsDetails) => {
    let periodsArrayToDisplay = [];
    for (let a = 0; a < periodsDetails.length; a++) {
        let dayObj = periodsDetails[a]
        for (let b = 0; b < dayObj.periods.length; b++) {
            let periodObj = dayObj.periods[b];
            if (periodObj.typeOfPeriod === "period" && !periodsArrayToDisplay.includes(periodObj.periodName)) {
                periodsArrayToDisplay.push(periodObj.periodName);
            }
        }
    }
    return periodsArrayToDisplay
}